import axios from "axios";

const GET_PROJECTS = "GET_PROJECTS";

const initialState = [];

export const getProjects = () => async (dispatch) => {
  const res = await axios.get("https://sheetdb.io/api/v1/40dkm1cnzxrpa");
  console.log('here is the data', res.data[0].tags);

    dispatch({
      type: GET_PROJECTS,
      payload: res.data,
    });
  
};

export const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECTS:
      return action.payload;
    default:
      return state;
  }
};
